(function() {
  'use strict';

  const AGE_GATE_KEY = 'ageGateVerified';
  const EXIT_URL = 'https://www.google.com'; // Change this to your exit URL

  function initAgeGate() {
    // Check if user is already verified
    const isVerified = localStorage.getItem(AGE_GATE_KEY);

    const modal = document.getElementById('age-gate-modal');
    if (!modal) {
      return; // Modal not found
    }

    if (isVerified === 'true') {
      // User is verified, hide modal and allow access
      modal.setAttribute('hidden', '');
      return;
    }

    // Show the age gate modal
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden'; // Prevent scrolling

    // Handle button clicks
    const buttons = modal.querySelectorAll('[data-age-gate]');
    buttons.forEach(button => {
      button.addEventListener('click', handleAgeGateResponse);
    });
  }

  function handleAgeGateResponse(event) {
    event.preventDefault();
    event.stopPropagation();

    const response = event.currentTarget.getAttribute('data-age-gate');
    const modal = document.getElementById('age-gate-modal');

    if (!modal) {
      return;
    }

    if (response === 'yes') {
      // User is 21 or older
      localStorage.setItem(AGE_GATE_KEY, 'true');
      modal.setAttribute('hidden', '');
      document.body.style.overflow = ''; // Restore scrolling
    } else if (response === 'no') {
      // User is under 21 - redirect away
      window.location.href = EXIT_URL;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAgeGate);
  } else {
    initAgeGate();
  }
})();


